import { PrimaryButton } from 'ui/button';
import noop from 'utils/noop';
import { useHyperlinkFormContext } from '../../contexts/hyperlinkForm';
import { useTranslation } from '../../../../../../../hooks/useTranslation';
import { useSetHyperlink } from '../../hooks/useSetHyperlink';
import { useSelectedHyperlink } from '../../../hooks/useSelectedHyperlink';

export const InsertLinkButton = () => {
  const { t } = useTranslation();
  const { handleSubmit } = useHyperlinkFormContext();
  const setHyperlink = useSetHyperlink();
  const selectedHyperlink = useSelectedHyperlink();

  const onClick = handleSubmit(
    ({ displayText, href, target }) => setHyperlink(displayText, href, target),
    noop,
  );

  return (
    <PrimaryButton onClick={onClick} data-test="insert-button">
      {t(
        selectedHyperlink
          ? 'contentPicker.textEditor.updateHyperlink'
          : 'contentPicker.textEditor.addHyperlink',
      )}
    </PrimaryButton>
  );
};
